import AttendanceSheetStatusIcon from '../../components/IconeStatus';
import Links from '@/shared/constants/navegacao';
import MyContext from '@/shared/contexts/AppContext';
import { AttendanceSheetPdf } from '../../components/AttendanceSheetPDF';
import { Button } from 'react-bootstrap';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { FaEye, FaRegFilePdf, FaUserTie, FaSignature } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { ListAllMonthsOfAnIntershipResponseDto, AttendanceSheetResponseDto } from '@/api.types';
import { MdOutgoingMail } from 'react-icons/md';
import { TiDocumentAdd } from 'react-icons/ti';
import { exportFromJsxToPdf } from '@/shared/utils/pdf';
import { readByIdAttendanceSheet } from '../../../attendance-sheet.service';
import { toast } from 'react-toastify';
import { useContext } from 'react';

interface Props {
  registros: ListAllMonthsOfAnIntershipResponseDto[];
  tableState: any;
  handleBuscar: () => void;
  setSelectedItem: (item: ListAllMonthsOfAnIntershipResponseDto) => void;
  setShowModalCriarFolha: (v: boolean) => void;
  setFolhaSelecionada: (row: ListAllMonthsOfAnIntershipResponseDto) => void;
  setShowModalResponsavel: (v: boolean) => void;
  setShowModalNotificacaoIndividual: (v: boolean) => void;
  setFolhaParaAssinaturas: (folha: AttendanceSheetResponseDto | null) => void;
  setShowModalAssinaturas: (v: boolean) => void;
}

export function PerInternTable({
  registros, tableState, handleBuscar,
  setSelectedItem, setShowModalCriarFolha,
  setFolhaSelecionada, setShowModalResponsavel,
  setShowModalNotificacaoIndividual,
  setFolhaParaAssinaturas, setShowModalAssinaturas,
}: Props) {
  const context = useContext(MyContext);
  if (!context)
    throw new Error('Contexto deve ser usado dentro de um Provedor.');

  const handlePrintAttendanceSheet = async (folhaId: string) => {
    try {
      const folha = await readByIdAttendanceSheet(folhaId);
      exportFromJsxToPdf(<AttendanceSheetPdf folha={folha} />)
    } catch (error) {
      toast.error(String(error));
    }
  };

  const handleShowAssinaturas = async (folhaId: string) => {
    try {
      const folha = await readByIdAttendanceSheet(folhaId);
      setFolhaParaAssinaturas(folha);
      setShowModalAssinaturas(true);
    } catch (error) {
      toast.error(String(error));
    }
  };

  const colunas: Column<ListAllMonthsOfAnIntershipResponseDto>[] = [
    { key: "index", header: "Nº", invisible: true },
    { key: "ano", header: "Ano" },
    {
      key: "mes", header: "Mês", render: (row) =>
        <span className="text-capitalize text-center">
          {new Date(0, row.mes - 1).toLocaleString('pt-BR', { month: 'long', })}
        </span>,
    },
    {
      key: "status", header: "Status", render: (row) =>
        <div className="text-center">
          {row.folha ? (
            <Link to={`${Links.Folha_Frequencia_Editar}/${row.folha.id}`}>
              <AttendanceSheetStatusIcon status={row.status} />
            </Link>
          ) : (
            context.state.username && (
              <Button
                className="btn btn-link link-secondary"
                onClick={() => {
                  setSelectedItem(row);
                  setShowModalCriarFolha(true);
                }}
                title="Criar folha de frequência."
              >
                <TiDocumentAdd size={25} color="#0cb389ff" />
              </Button>
            )
          )}
        </div>
    },
    {
      key: "folha.editadoem",
      header: "Editado Em",
      render: (row) =>
        row.folha && row.folha.editadoem
          ? new Date(row.folha.editadoem).toLocaleDateString('pt-BR', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })
          : '',
    },
    {
      key: "acoes", header: "Ações", render: (row) =>
        row.folha ? (
          <div className="d-flex align-items-center">
            <Link
              className="link-secondary me-3"
              to={`${Links.Folha_Frequencia_Editar}/${row.folha.id}`}
              title="Visualizar a folha."
            >
              <FaEye size={24} color="#0daaaf" />
            </Link>
            <Button
              className="btn btn-link link-secondary"
              onClick={() => handlePrintAttendanceSheet(row.folha!.id)}
              title="Gerar PDF da folha."
            >
              <FaRegFilePdf size={22} color="#ff4444" />
            </Button>
            {context.state.username && (
              <>
                <Button
                  className="btn btn-link link-secondary"
                  onClick={() => {
                    setFolhaSelecionada(row);
                    setShowModalResponsavel(true);
                  }}
                  title="Definir responsável."
                >
                  <FaUserTie size={18} color="#555555" />
                </Button>
                <Button
                  className="btn btn-link link-secondary"
                  onClick={() => {
                    setFolhaSelecionada(row);
                    setShowModalNotificacaoIndividual(true);
                  }}
                  title="Notificar."
                >
                  <MdOutgoingMail size={24} color="#449623ff" />
                </Button>
                <Button
                  className="btn btn-link link-secondary"
                  onClick={() => handleShowAssinaturas(row.folha!.id)}
                  title="Ver assinaturas e justificativas."
                >
                  <FaSignature size={20} color="#6c757d" />
                </Button>


              </>
            )}

          </div>
        ) : null
    },
  ];

  return (
    <DataTable
      columns={colunas}
      data={registros}
      initialSortKey="ano"
      showFilter={false}
      onChange={handleBuscar}
      serverSide={false}
      states={tableState}
      totalRecords={registros?.length}
      disablePagination={true}
      pageSizeOptions={[1000]}
    />
  );
}

